import React from 'react';
import { useSelector } from 'react-redux';
import Button from '@/app/components/Button';
import { profileMenuItem } from '../menuList';
import UserAccountV2 from '../../Input/UserAccountV2';
import TextSmall from '../../Typography/TextSmall';

function SignUpLogIn({ onOpenLoginSignup = () => {} }) {
  const { isLoggedIn } = useSelector((state) => state.auth);

  return isLoggedIn ? (
    /* profile menu */
    <UserAccountV2 option={profileMenuItem} />
  ) : (
    <div className="flex justify-center items-center gap-2">
      <Button type="link" className="!p-0" onClick={onOpenLoginSignup}>
        <TextSmall
          text="Sign Up"
          className="text-sm lg:text-sm lg:leading-5 text-white font-medium hover:underline"
        />
      </Button>
      <span className="text-sm lg:text-base font-medium hover:underline">
        {' '}
        |{' '}
      </span>
      <Button type="link" className="!p-0" onClick={onOpenLoginSignup}>
        <TextSmall
          text="Log In"
          className="text-sm lg:text-sm lg:leading-5 text-white font-medium hover:underline"
        />
      </Button>
    </div>
  );
}

export default SignUpLogIn;
